import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Tag } from "@/model/data/Tag";

const ENDPOINT = "/device/";

export class EdiDeviceInfoCommand extends Command {
  endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
  httpVerb: HttpVerbType = "patch";
  payload: EditDeviceInfoRequestData;

  constructor(payload: EditDeviceInfoRequestData) {
    super();
    this.payload = payload;
  }

  public async execute(): Promise<ApiGenericResponse> {
    var res = await this.executeCommand(this.payload);
    return new ApiGenericResponse(res);
  }
}

export class EditDeviceInfoRequestData {
  installationName: string;

  public branchName: string | undefined = undefined;
  public tagList: Tag[] = undefined;

  constructor(installationName: string) {
    this.installationName = installationName;
  }

  public addTag(key: string, value: string) {
    if (!this.tagList) this.tagList = [];
    var t = new Tag();
    t.name = key;
    t.value = value;
    this.tagList.push(t);
  }
}
